import InviraRolesDelete from './InviraRolesDelete.vue'
export {InviraRolesDelete}
export default InviraRolesDelete

